import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { AppContext, useProduct, COMMON_CONSTANTS } from '../../../index';
import { AccountClient } from '@nile/graphql';
import { GET_CLIENT_DATA } from '@nile/graphql/src/Query/ticket';
import {
  POLICY_MANAGEMENT_TYPE,
  POLICY_RMM_TRANSITION,
  MIGRATION_STATUS_TYPES
} from '@nile/rmm/src/constants';

interface UseAdvancedHierarchyParams {
  client?: any;
  clientId?: string;
}

export const useAdvancedHierarchy = (params?: UseAdvancedHierarchyParams) => {
  const { client, clientId } = params || {};
  const appContext = useContext(AppContext);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  // Check for advanced hierarchy
  const isAdvanceHierarchyCompleted =
    (appContext as any)?.rmmProperties?.['rmm.policyManagementType'] ===
    POLICY_MANAGEMENT_TYPE.ADVANCED_HIERARCHY;
  const enabledAdvancedHierarchy =
    (appContext as any)?.rmmProperties?.['rmm.AdvancedHierarchyTransition'] ===
    POLICY_RMM_TRANSITION.started;

  // Fetch client data if MSP product
  const { data: clientData } = useQuery(GET_CLIENT_DATA, {
    client: AccountClient,
    variables: {
      clientId: clientId || client?.accountId
    },
    skip: !isMSPProduct || (!clientId && !client?.accountId)
  });

  const getAdvancedHierarchyStatus = () => {
    if (isAdvanceHierarchyCompleted) {
      return true;
    }
    if (isMSPProduct) {
      const migrationStatus =
        clientData?.getClient?.policyMigrationStatus ||
        client?.policyMigrationStatus;
      return (
        migrationStatus === MIGRATION_STATUS_TYPES.completed &&
        enabledAdvancedHierarchy
      );
    }
    return false;
  };

  const isAdvancedHierarchy = getAdvancedHierarchyStatus();

  return {
    isAdvancedHierarchy,
    isMSPProduct
  };
};
